import { useConfig } from "..";
import type { Exactly } from "../../../utils/types";
import SafeConfigSchema from "./index.schema";
import type { SafeConfig } from "./index.types";

export const useSafeConfigSlice = <K extends keyof SafeConfig>(
	keys: Array<K>,
) => {
	const config = useConfig();

	const pickShape = Object.fromEntries(
		keys.map((key) => [key, true]),
	) as Exactly<Partial<Record<K, true>>, true>;

	const schema = SafeConfigSchema.pick(pickShape);
	return schema.parse(config);
};

export const useSafeConfigValue = <K extends keyof SafeConfig>(key: K) => {
	const config = useConfig();
	const pickShape = { [key]: true } as Exactly<Partial<Record<K, true>>, true>;
	const schema = SafeConfigSchema.pick(pickShape);
	const slice = schema.parse(config);
	return slice[key as keyof typeof slice];
};

export const getSafeConfigValue = <K extends keyof SafeConfig>(
	config: Record<string, any>,
	key: K,
) => {
	const pickShape = { [key]: true } as Exactly<Partial<Record<K, true>>, true>;
	const schema = SafeConfigSchema.pick(pickShape);
	const slice = schema.parse(config);
	return slice[key as keyof typeof slice];
};

const useSafeConfig = () => {
	const config = useConfig();
	return SafeConfigSchema.parse(config);
};

export default useSafeConfig;
